<template>
  <div>
    <home-header />
    <div class="content page-width">
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-2">
          <div class="personalimg">
            <img :src="userInfo.avatar
                    ? userInfo.avatar
                    : userInfo.sex === '1'
                    ? `https://stu8.jxjypt.cn/nan.jpg`
                    : `https://stu8.jxjypt.cn/nv.jpg`" width="94" height="94"/>
          </div>
          <h1>{{userInfo.name}}<span class="grade">({{userInfo.grade}})</span></h1>
          <div class="margin-bottom-20 mymajor">专业：{{userInfo.proName}}</div>
          <div class="margin-bottom-20 mymajor">登录次数：{{userInfo.loginCount}}</div>
          <ul class="centerli">
            <li class="centerli-top">个人中心</li>
            <li> <router-link to="/personalcenters/myinfo" active-class="active" exact>我的信息</router-link></li>
            <li v-if="$store.state.homeObj.archive_change_show != '0'">
              <router-link to="/personalcenters/changestate" active-class="active">学籍异动申请表</router-link>
            </li>
            <li v-if="$store.state.homeObj.exam_post != '0'">
              <router-link to="/personalcenters/examPost" active-class="active">缓考申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.doc_info_collection_show === '1'">
              <router-link to="/personalcenters/infocollect" active-class="active">信息采集</router-link>
            </li>
            <!-- <li> <router-link target="_blank" to="/personalcenters/infocollectindex" active-class="active">信息采集</router-link></li> -->
            <!-- <li> <router-link to="/personalcenters/startstate" active-class="active">入学登记表</router-link></li> -->
            <!-- <li> <router-link to="/personalcenters/RegistrationCheck" active-class="active">毕业资格审查表</router-link></li> -->
            <!-- <li> <router-link to="/personalcenters/registrationform" active-class="active">学生毕业登记表</router-link></li> -->
            <li v-if="$store.state.homeObj.unpaidTuitionFlag !== '0'">
              <router-link to="/mypersonal/tuitionfeethis" active-class="active">我的学费</router-link>
            </li>
            <li v-if="$store.state.homeObj.show_fee === '1'">
              <router-link to="/personalcenters/payment" active-class="active">{{homeObj.edu_fee_name}}</router-link>
            </li>
            <li v-if="$store.state.homeObj.exam_mode === '2'">
              <router-link to="/personalcenters/applyOfflineExam" active-class="active" exact>预约线下考试</router-link>
            </li>
            <li v-if="$store.state.homeObj.feedBack_show === '1'">
              <router-link to="/personalcenters/FeedBack" active-class="active">意见反馈</router-link>
            </li>
            <li v-if="$store.state.homeObj.photo_show === '1'">
              <router-link to="/personalcenters/getStuPhoto" active-class="active">毕业生照片采集</router-link>
            </li>
            <li v-if="$store.state.homeObj.gra_apply_enable !='0'"><router-link to="/graduation/apply" active-class="active">毕业或学位申请</router-link></li>
            <li v-if="$store.state.homeObj.storage_show === '1'">
              <router-link to="/personalcenters/fileStorage" active-class="active">个人云盘</router-link></li>
            <li> <router-link to="/personalcenters/forgetpassword" active-class="active">修改密码</router-link></li>
            <li> <router-link to="/personalcenters/SecuritySetting" active-class="active">安全中心</router-link></li>
          </ul>
        </div>
        <div class="col-md-10">
           <router-view />
        </div>
      </div>
      <ul>
        <li></li>
      </ul>

    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import InsidePageBannar from '@/common/components/InsidePageBannar'
import InsidePageLeft from '@/common/components/InsidePageLeft'
import Foot from '@/common/components/Foot'
import Fade from '@/common/fade/FadeAnimation'
import MajorList from './components/MajorList'
import SecuritySetting from './components/SecuritySetting'
import axios from 'axios'
import { mapState } from "vuex";
export default {
  name: 'PersonalCenters',
  components: {
    HomeHeader,
    InsidePageBannar,
    Foot,
    MajorList,
    InsidePageLeft,
    Fade,
    SecuritySetting
  },
  data: function () {
    return {
      arrs: [],
      sex: true,
    }
  },
  methods: {
    getDetailInfo () {
      // axios.get('http://localhost:8080/static/mock/index.json').then(this.handleGetDataSucc)
    },
    handleGetDataSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.arrs = data.course
      }
    },
  },
  created(){
  },
  mounted () {
    this.getDetailInfo()
  },
    computed: {
    ...mapState(["userInfo","homeObj"]),
  },
}
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .page-width{
    width:$pageWidth;
    margin:0 auto;
  }
  .content{
    margin-top:30px;
    background:#fff;
    padding:28px;
    margin-bottom:30px;
    min-height:500px;
    .col-md-2{
      min-height:500px;
      border-right:3px solid #edeff5;
      text-align:center;
      .active{
        background:$bgColor;
        color:#fff;
      }

    }
  }
  .centerli{
    background:$bgcontent;
    border-radius:10px;
    padding-bottom:30px;
    overflow:hidden;
    padding-top:20px;
    .centerli-top{
      padding:15px 0;
      font-size:18px;
      color:$bgColor;
      font-weight:bold;
    }
    li{
      margin:0px 10px;
      a{
        display:inline-block;
        width:100%;
        padding:15px 0;
        border-bottom:1px solid  #eaeaea;
        color:#999;

      }
    }
  }
  h1{
    font-size:24px;
    margin-bottom:10px;
    margin-top:20px;
    .grade{
      font-size:15px;
      margin-left:15px;
      color:#666;
    }
  }
  .personalimg{
    img{
      width:112px;
      height:125px;
    }
  }
  .mymajor{
    color:#999;
    margin-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/Index.vue